/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
/*
 * Author M. Atoar Rahman
 * Title: Expired Medicine DataTable
 * Description: Expired Medicine DataTable
 * Date: 15/03/2022
 */

import moment from 'moment';
import useDataTable from '../../../hooks/useDataTable';
import { useNearlyExpiredMedicine } from './ContextAPI';

export default function DataTable() {
    const { partnerInfo } = useNearlyExpiredMedicine();

    const tableStyle = {
        paddingLeft: '5px',
        paddingRight: '5px',
        lineHeight: '33px',
    };

    function ItemTitle() {
        return <span className="ps-2">Item Name</span>;
    }

    function Title() {
        return (
            <table className="table table-bordered mb-0 text-center" style={tableStyle}>
                <thead>
                    <tr style={{ borderTopWidth: '0px', borderBottomWidth: '0px' }}>
                        <th style={{ lineHeight: '34px' }} width="100px" className="m-0">
                            Batch No
                        </th>
                        <th width="100px" className="m-0">
                            Supply Date
                        </th>
                        <th width="100px" className="m-0">
                            Mfg. Date
                        </th>
                        <th width="100px" className="m-0">
                            Expired Date
                        </th>
                        <th width="100px" className="m-0">
                            Unit Qty
                        </th>
                        <th width="100px" className="m-0">
                            Unit Price (BDT)
                        </th>
                        <th width="100px" className="m-0">
                            Total Amount (BDT)
                        </th>
                    </tr>
                </thead>
            </table>
        );
    }

    const columns = [
        {
            name: <ItemTitle />,
            cell: (row) => <span className="ps-2">{row.drug_name}</span>,
            sortable: true,
            wrap: true,
            width: '280px',
            fixed: true,
            style: { borderBottom: '1px solid #ddd' },
        },
        {
            name: <Title />,
            cell: (row) => (
                <table className="table table-bordered mb-0 text-center" style={tableStyle}>
                    <tbody>
                        {row?.batch_info?.map((item) => (
                            <tr key={Math.random() * 1000} style={{ borderTopWidth: '0px' }}>
                                <td width="100px" className="m-0">
                                    {item.batch_no}
                                </td>
                                <td width="100px" className="m-0">
                                    {moment(item.supply_date).format('DD MMM YYYY')}
                                </td>
                                <td width="100px" className="m-0">
                                    {moment(item.mfg_date).format('DD MMM YYYY')}
                                </td>
                                <td width="100px" className="m-0">
                                    {moment(item.expire_date).format('DD MMM YYYY')}
                                </td>
                                <td width="100px" className="m-0">
                                    {item.available_qty}
                                </td>
                                <td width="100px" className="m-0">
                                    {Math.floor(item.unit_price)}
                                </td>
                                <td width="100px" className="m-0">
                                    {Math.floor(item.unit_price * item.available_qty)}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            ),
        },
    ];

    const search_column = { name: 'Name' };
    return useDataTable({
        columns,
        data: partnerInfo,
        search_column,
        pagination: false,
        cellPadding: '0px',
        borderWidth: '0px',
        tableHeight: '100%',
    });
}
